export enum TextFontStyle {
  Italic = 'italic',
  Normal = 'normal'
}
